module.exports = __webpack_public_path__ + "img/Juggernaut.42b847ed.png";